/**
 * Generic theme support, to be combined with theme-specific support modules
 */
(function() {
  angular.module('theme', [])

  // Lookup icon from theme icon map
  .service('theme', function() {
    // Fetch icon classes from the $theme.icons object
    this.icon = function(name) {
      var classes, iconValue, ref;

      classes = ['icon'];

      if (this.iconBaseClass != null) {
        classes.push(this.iconBaseClass);

        // This theme uses material design icons for everything
        if (this.iconBaseClass === 'material-icons') {
          if ((this.icons != null) && (this.icons[name] != null)) {
            // Since we can't modify html from here, attempt a substitute class
            classes.push(this.iconBaseClass + "-" + this.icons[name]);
          }
          return classes;
        }
      }

      if (((ref = this.icons) != null ? ref[name] : void 0) != null) {
        iconValue = this.icons[name];
        if (angular.isString(iconValue)) {
          // Single class
          classes.push(iconValue);
        } else if (angular.isArray(iconValue)) {
          // Multiple classes
          classes = classes.concat(iconValue);
        } else if (iconValue.content != null) {
          // Icon with html content
          // Since we can't modify html from here, attempt a substitute class
          classes.push(iconValue["class"] + "-" + iconValue.content);
        }
      }

      return classes;
    };

    this.colors = {};
    this.colours = function() { return this.colors; };

    this.customIcons = [
      'meter',
      'calendar',
      'bullhorn',
      'dumbbell',
      'graph',
      'band-aid',
      'first-aid-kit',
      'clipboard',
      'star-jump',
      'shield',
      'shopping-cart',
      'cog',
      'envelope',
      'images',
      'key',
      'video',
      'wrench',
      'trophy',
      'tree',
      'ticket',
      'pie-report',
      'stack',
      'radio',
      'pie-chart',
      'building',
      'notebook',
      'dashboard',
      'home',
      'inbox',
      'cube',
      'bed',
      'balance',
      'books',
      'briefcase',
      'clock',
      'location-marker',
      'moon',
      'sliders',
      'smiley',
      'card'
    ];
  })


  .directive('themeIcon', [
    '$q', '$compile', 'theme', function($q, $compile, theme) {
      return {
        restrict: 'A',
        scope: {
          'themeIcon': '='
        },
        link: function(scope, element, attrs) {
          var applyIconName, currentName;

          element.addClass('icon');
          element.attr('aria-hidden', 'true');

          if (theme.iconBaseClass != null) {
            element.addClass(theme.iconBaseClass);
          }

          applyIconName = function(name, compile) {
            // This theme uses material design icons for everything
            var i, iconValue, klass, len, ref, ref1;

            if (theme.iconBaseClass === 'material-icons') {
              if (((ref = theme.icons) != null ? ref[name] : void 0) != null) {
                element.html(theme.icons[name]);
              }
              return;
            }

            if (((ref1 = theme.icons) != null ? ref1[name] : void 0) != null) {
              iconValue = theme.icons[name];
              if (angular.isString(iconValue)) {
                // Single class
                element.addClass(iconValue);
              } else if (angular.isArray(iconValue)) {
                // Multiple classes
                for (i = 0, len = iconValue.length; i < len; i++) {
                  klass = iconValue[i];
                  element.addClass(klass);
                }
              } else if (iconValue.content != null) {
                // Icon with html content
                element.addClass(iconValue["class"]);
                element.html(iconValue.content);
              }
            }
          };

          if (scope.themeIcon != null) {
            // Icon name is already here
            applyIconName(scope.themeIcon);
            return;
          }

          // Wait until icon name is given
          currentName = null;
          scope.$watch('themeIcon', function(name) {
            if ((name != null) && name !== currentName) {
              applyIconName(name);
              $compile(element)(scope);
            }
          });
        }
      };
    }
  ]);
}).call(this);
